// State
export const state = () => ({
  promotions: [],
  promotionId: [],
  loading: false
})

// Actions
export const actions = {
  // get all promotions
  async promotions({ commit }) {},
  async promotionCode({ commit }, form) {},
  async claimNowRolling({ commit }, form) {}
}

// Mutations
export const mutations = {
  setPromotion: (state, v) => {
    state.promotionId = v
  },
  setPromotions: (state, data) => {
    state.promotions = data
  },
  loading: (state, type) => {
    state.loading = type
  }
}

// Getters
export const getters = {
  promotions: state => {
    return state.promotions
  }
}
